module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/title/title-opening-hours-fb03e6166cba5b3ace84f2bf4ce0bf7b.svg&quot;;"